// extracted by mini-css-extract-plugin
export default {"MainCont":"Proofing_MainCont__FEnPH","LeftCont":"Proofing_LeftCont__6Bj4u","RightCont":"Proofing_RightCont__SP4ML"};